import { ticketCreateDescription as description } from './description';
import { createTicket as execute } from './execute';

export { description, execute };
